export default (data) => ({
    _formSubmitMethod: null,
    _els: {
        submitButton: null,
        alert: null,
    },
    _components: {
        fields: new Map(),
        submitButton: null,
    },
    init() {
        this.$nextTick(() => {
            this._setFieldInstances();
            this.submitButton?.$data?.setDisabledStateTo(!this.canSubmit);
        });
    },

    /**
     * @returns {Map|Field[]}
     */
    get fields() {
        return this._components.fields;
    },

    /**
     * @returns {Btn|null}
     */
    get submitButton() {
        if (this._components.submitButton) {
            return this._components.submitButton;
        }

        if (!this._els.submitButton) {
            this._els.submitButton = this.$el.querySelector('button[type="submit"]');

            if (!this._els.submitButton) {
                const btns = this.$el.querySelectorAll('button');

                this._els.submitButton = btns.length ? btns[btns.length - 1] : null;
            }
        }

        if (!this._els.submitButton) {
            return null;
        }

        return this._els.submitButton.__x ?? null;
    },

    /**
     * @returns {boolean}
     */
    get isLoading() {
        return this.submitButton?.$data?.loading;
    },

    refreshFields() {
        this._components.fields.clear();

        this._setFieldInstances();
    },

    /**
     * @param {string} name
     * @returns {Field|null}
     */
    field(name) {
        let field = this._components.fields.get(name);

        if (field instanceof Map) {
            field = field.values().next().value;
        }

        return field || null;
    },

    /**
     * @param {string} name
     * @returns {HTMLElement|null}
     */
    error(name) {
        return this.field(name)?.$data?.error;
    },

    /**
     * @param {string} name
     * @returns {boolean}
     */
    hasError(name) {
        return !!this.error(name);
    },

    /**
     * @returns {boolean}
     */
    get hasErrors() {
        // const loop = (items) => Array.from(items).filter(item => !(item instanceof Map) ? !!item.error : loop(item)).length > 0;

        // return loop(this.fields.values());


        // TODO: Do this in a better, more "reactive"/"automatic" way (just fix the babove code).
        return !!this.$el.querySelector('.is-invalid .field-feedback');
    },

    /**
     * @param {boolean} name
     */
    setLoadingStateTo(value) {
        this.submitButton?.$data?.setLoadingStateTo(value);
    },

    /**
     * @param {boolean} shouldIgnoreErrors
     * @returns {boolean}
     */
    isValid(shouldIgnoreErrors = false) {
        if (shouldIgnoreErrors) {
            return this.$el.checkValidity();
        }

        return this.$el.checkValidity() && !this.hasErrors;
    },

    /**
     * @param {string} html
     */
    setAlert(html) {
        if (!(html || '').trim()) {
            return;
        }

        if (this._els.alert) {
            this._els.alert?.remove();
        }

        const container = document.createElement('div');

        container.innerHTML = html;

        this._els.alert = container.firstElementChild;

        this.$el.insertBefore(this._els.alert, this.$el.firstElementChild);

        if (typeof this._els.alert.scrollIntoView === 'function') {
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
            this._els.alert.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
    },

    removeAlert() {
        this._els.alert?.remove();

        this._els.alert = null;
    },

    /**
     * @returns {Boolean}
     */
    get hasData() {
        return !!Array.from(this.data.values()).filter(value => !!value).length;
    },

    /**
     * @returns {Boolean}
     */
    get isEmpty() {
        return !this.hasData;
    },

    /**
     * @returns {FormData}
     */
    get data() {
        return new FormData(this.$el);

        // const data = new FormData;

        // const value = (field) => {
        //     if (['radio', 'checkbox'].includes(field.type)) {
        //         return field.$data.isChecked ? (field.$data.value || field.$data.isChecked) : null;
        //     }

        //     if (field.$data.type === 'file') {
        //         if (!field.$data.files?.length) {
        //             return null;
        //         }

        //         if (!field.$data.allowsMultiple) {
        //             return field.$data.files[0];
        //         }

        //         return Array.from(field.$data.files);
        //     }

        //     if ((field.$data.type === 'select') && field.$data.allowsMultiple) {
        //         return Array.from(field.$data.$el.selectedOptions).map(option => option.value || option.text);
        //     }

        //     return field.$data.value;
        // };
        // const acceptsArrayValues = (field) => (
        //     (
        //         ['select', 'file'].includes(field.$data.type)
        //         && field.$data.allowsMultiple
        //     )
        //     || (field.$data.type === 'checkbox')
        // );
        // const append = (field) => {
        //     let val = value(field);

        //     if (!this._isFilled(val)) {
        //         return;
        //     }

        //     if (!acceptsArrayValues(field)) {
        //         data.append(field.$data.name, !Array.isArray(val) ? val : val[0]);

        //         return;
        //     }

        //     if (!Array.isArray(val)) {
        //         val = [val];
        //     }

        //     val.forEach(_val => data.append(field.$data.name, _val));
        // }

        // this.fields.forEach(field => {
        //     if (!(field instanceof Map)) {
        //         append(field);

        //         return;
        //     }

        //     field.forEach(append);
        // });

        // Array.from(data.entries()).forEach(([name, value]) => {
        //     if (!this._isFilled(value)) {
        //         data.delete(name);
        //     }
        // });

        // return data;
    },

    reset() {
        this.setLoadingStateTo(false);
        this.removeAlert();

        this.fields.forEach(field => {
            if (!(field instanceof Map)) {
                field?.$data?.reset();

                return;
            }

            field.forEach(item => item?.$data?.reset());
        });

        setTimeout(() => {
            this.submitButton?.$data?.setDisabledStateTo(!this.canSubmit);
        }, 0);
    },

    /**
     * @returns {Boolean}
     */
    get canSubmit() {
        if (this.isLegacyBrowser) {
            return true;
        }

        return this.isValid();
    },

    /**
     * @param {function} callback
     * @returns {Promise}
     */
    async submit(callback = null) {
        if (!this.canSubmit) {
            return Promise.reject(new Error('Invalid form values'));
        }

        this.removeAlert();
        this.setLoadingStateTo(true);

        const request = callback ? callback(this) : this._sendSubmitRequest();

        if (!request || (typeof request?.then !== 'function')) {
            this.setLoadingStateTo(false);

            return Promise.resolve();
        }

        return request
            .then(response => {
                this.reset();

                if (response?.data?.alert) {
                    this.setAlert(response.data.alert);
                }

                let responseURL = response?.request?.responseURL;

                // For legacy browsers
                if (!responseURL && !('responseURL' in XMLHttpRequest.prototype) && response.data) {
                    // This could be an another option and would require the server to set a custom header
                    // responseURL = response?.request?.getResponseHeader('X-Redirect-To');

                    const html = document.createElement('html');

                    html.innerHTML = response.data;

                    responseURL = html.querySelector('link[rel="canonical"]')?.href;
                }

                if (responseURL && (responseURL !== location.href) && (responseURL !== response?.config?.url)) {
                    location.href = responseURL;

                    return;
                }
            })
            .catch(({ response }) => {
                this.setLoadingStateTo(false);

                if (response?.status !== 422) {
                    if (response?.data?.alert) {
                        this.setAlert(response.data.alert);
                    }

                    return;
                }

                const errors = response?.data?.errors ?? {};
                const keys = Object.keys(errors);

                keys.forEach(key => {
                    if (!key.includes('.')) {
                        this.field(key)?.$data?.setError(errors[key][0] ?? errors[key]);

                        return;
                    }

                    this.field(key.split('.')[0])?.$data?.setError(errors[key][0] ?? errors[key]);
                });

                this.submitButton?.$data?.setDisabledStateTo(!this.canSubmit);
            });
    },

    onChange(e) {
        this._handleFieldChange(e);
    },
    /**
     * @param {SubmitEvent} e
     */
    onSubmit(e) {
        e.preventDefault();

        this.submit();
    },

    _setFieldInstances() {
        this.$children('field').forEach(instance => this._setFieldInstance(instance));
    },
    _setFieldInstance(instance) {
        const name = instance.unobservedData.name;

        if (!this._components.fields.has(name)) {
            this._components.fields.set(name, instance);

            return;
        }

        let items = this._components.fields.get(name);

        if (!(items instanceof Map)) {
            const map = new Map();

            map.set(items, items);

            items = map;
        }

        items.set(instance, instance);

        this._components.fields.set(name, items);
    },

    _handleFieldChange(e) {
        const field = e.target?.__x;

        if (!field) {
            return;
        }

        // @see https://developer.mozilla.org/en-US/docs/Web/API/Constraint_validation
        if (!field.$el.validity.valid) {
            field.unobservedData.setError(field.$el.validationMessage);
        }

        if (!this.submitButton) {
            return;
        }

        this.submitButton?.$data?.setDisabledStateTo(!this.canSubmit);
    },

    _isFilled(value) {
        if ([undefined, null, 'undefined', 'null'].includes(value)) {
            return false;
        }

        if (('' + value).trim() === '') {
            return false;
        }

        if (value === false || value === true) {
            return true;
        }

        if (value === 0 || value === '0') {
            return true;
        }

        return !!value;
    },

    _sendSubmitRequest() {
        if (!this._formSubmitMethod) {
            this._formSubmitMethod = this.$el.querySelector('input[type="hidden"][name="_method"]')?.value ?? this.$el.method ?? 'POST';
        }

        const data = this.data;

        // Special token fields. Not to confuse with the "_token" CSRF field.
        const token = this.$el.querySelector('input[type="hidden"][name="token"]')?.value;

        if (token) {
            data.append('token', token);
        }

        return axios({
            method: this._formSubmitMethod,
            url: this.$el.action,
            data,
        });
    },
});